export const BUS_SEARCH_FORM_SET_ORIGIN = 'BUS_SEARCH_FORM/SET_ORIGIN';
export const BUS_SEARCH_FORM_SET_DESTINATION =
  'BUS_SEARCH_FORM/SET_DESTINATION';
export const BUS_SEARCH_FORM_SET_DEPARTURE_DATE =
  'BUS_SEARCH_FORM/SET_DEPARTURE_DATE';

export const setOrigin = autoCompleteItem => {
  return {
    type: BUS_SEARCH_FORM_SET_ORIGIN,
    payload: autoCompleteItem,
  };
};

export const setDestination = autoCompleteItem => {
  return {
    type: BUS_SEARCH_FORM_SET_DESTINATION,
    payload: autoCompleteItem,
  };
};

export const setDepartureDate = date => {
  return {
    type: BUS_SEARCH_FORM_SET_DEPARTURE_DATE,
    payload: date,
  };
};
